<template>
    <div
        class="register-message-cont"
        :class="{ 'register-mobile-cont': isMobile }"
    >
        <!-- 输入邮箱--step1 -->
        <div v-show="createAccountStep === 1" class="email-address-input-cont">
            <n-form
                ref="registerEmailFormRef"
                :model="registerEmail"
                :rules="registerEmailRules"
            >
                <n-form-item
                    path="email"
                    label="Email Address"
                    :theme-overrides="formItemThemeOverrides"
                >
                    <n-input
                        v-model:value="registerEmail.email"
                        placeholder="Enter your Email Address"
                        size="large"
                        @keydown.enter.prevent
                    >
                        <template #suffix>
                            <n-icon
                                v-show="showRegisterEmailClearBtn"
                                class="btn-icon"
                                size="16"
                                @click="_handleClearRegisterEmail"
                            >
                                <img
                                    src="@/assets/icons/icon_input_clear_plain.svg"
                                />
                            </n-icon>
                        </template>
                    </n-input>
                </n-form-item>
            </n-form>

            <div class="next-btn-cont">
                <div class="term-of-privacy">
                    <n-checkbox v-model:checked="agreeAuthTermOfPrivacy"></n-checkbox>
                    By continuing, I agree that I am at least 18 years old and have read the 
                    <span @click="_handleShowTermsOfService">terms of service</span> and <span @click="handleShowPrivacyPolicy">privacy policy</span>.
                </div>
                <n-button
                    :color="
                        !isDisabledRegisterEmailBtn
                            ? '#000000'
                            : 'rgba(0, 0, 0, 0.2)'
                    "
                    text-color="#ffffff"
                    icon-placement="right"
                    :disabled="isDisabledRegisterEmailBtn"
                    @click="_handleValidEmail"
                >
                    <template v-if="isDisabledRegisterEmailBtn">
                        Next
                    </template>
                    <template v-else> Verify </template>
                </n-button>
            </div>

            <div class="tips-privacy-container">
                <div class="log-in-tip">
                    Already have an account?
                    <span @click="_handleShowLogin">Log in</span>
                </div>
            </div>
        </div>

        <!-- 等待验证身份--step2 -->
        <div v-show="createAccountStep === 2" class="verify-identity-cont">
            <div class="verify-identity-icon">
                <n-icon class="setpassword-icon">
                    <img src="@/assets/icons/icon_set_password.svg">
                </n-icon>
            </div>
            <div class="verify-identity-title">
                <span>Set Password</span>
            </div>
            <div class="has-sended-message">
                We have sent you an email to verify that your email address is
                <span>{{registerEmail.email}}</span>
            </div>

            <div class="btn-group">
                <div class="custom-btn resend-btn" @click="_hanleResendEmail">
                    Resend Verification Email
                </div>
                <!-- <div class="custom-btn check-btn" @click="_hanleCheckVerify">
                    Check Verify
                </div> -->
            </div>
        </div>

        <!-- 输入注册账号的昵称及密码--step3 -->
        <div
            v-show="createAccountStep === 3"
            class="account-message-input-cont"
        >
            <n-form
                ref="registerFormRef"
                :model="registerMessageModel"
                :rules="registerMessageModelRules"
            >
                <n-form-item
                    path="nickname"
                    label="User Name"
                    :theme-overrides="formItemThemeOverrides"
                >
                    <n-input
                        v-model:value="registerMessageModel.nickname"
                        :placeholder="userNamePlaceholder"
                        size="large"
                        @keydown.enter.prevent
                    >
                        <template #suffix>
                            <n-icon
                                v-show="showRegisterUserNameClearBtn"
                                class="btn-icon"
                                size="16"
                                @click="_handleClearRegisterUserName"
                            >
                                <img
                                    src="@/assets/icons/icon_input_clear_plain.svg"
                                />
                            </n-icon>
                        </template>
                    </n-input>
                </n-form-item>
                <n-form-item
                    path="password"
                    label="Password"
                    :theme-overrides="formItemThemeOverrides"
                >
                    <n-input
                        v-model:value="registerMessageModel.password"
                        :type="showRegisterPassword ? 'text' : 'password'"
                        placeholder="Enter Your Password"
                        size="large"
                        autocomplete
                        @keydown.enter.prevent
                    >
                        <template #suffix>
                            <n-icon
                                class="btn-icon"
                                size="24"
                                @click="_handleShowRegisterPassword"
                            >
                                <img
                                    v-if="showRegisterPassword"
                                    src="@/assets/icons/icon_layout_eye.svg"
                                />
                                <img
                                    v-else
                                    src="@/assets/icons/icon_layout_password.svg"
                                />
                            </n-icon>
                            <n-icon
                                v-show="showRegisterPasswordClearBtn"
                                class="btn-icon"
                                size="16"
                                @click="_handleClearRegisterPassword"
                            >
                                <img
                                    src="@/assets/icons/icon_input_clear_plain.svg"
                                />
                            </n-icon>
                        </template>
                    </n-input>
                </n-form-item>
                <n-form-item
                    path="confirmPassword"
                    label="Re-enter your Password"
                    :theme-overrides="formItemThemeOverrides"
                >
                    <n-input
                        v-model:value="registerMessageModel.confirmPassword"
                        :type="
                            showRegisterConfirmPassword ? 'text' : 'password'
                        "
                        placeholder="Confirm Your Password"
                        size="large"
                        @keydown.enter.prevent
                    >
                        <template #suffix>
                            <n-icon
                                class="btn-icon"
                                size="24"
                                @click="_handleShowRegisterConfirmPassword"
                            >
                                <img
                                    v-if="showRegisterConfirmPassword"
                                    src="@/assets/icons/icon_layout_eye.svg"
                                />
                                <img
                                    v-else
                                    src="@/assets/icons/icon_layout_password.svg"
                                />
                            </n-icon>
                            <n-icon
                                v-show="showRegisterConfirmPasswordClearBtn"
                                class="btn-icon"
                                size="16"
                                @click="_handleClearRegisterConfirmPassword"
                            >
                                <img
                                    src="@/assets/icons/icon_input_clear_plain.svg"
                                />
                            </n-icon>
                        </template>
                    </n-input>
                </n-form-item>
            </n-form>

            <div class="create-account-btn-cont">
                <n-button
                    :color="!isDisabledCreateAccount ? '#000000' : 'rgba(0, 0, 0, 0.2)'"
                    text-color="#ffffff"
                    :disabled="isDisabledCreateAccount"
                    @click="_handleCreateAccount"
                >
                    Create
                </n-button
                >
            </div>
        </div>

        <!-- 选择职业--step4 -->
        <!-- <div v-show="createAccountStep === 4" class="choose-career">
            <ChoseUserIdentify
                :cur-role-type="cacheUserRole"
                @on-next="_handleChooseCareerNext"
            ></ChoseUserIdentify>
        </div> -->

        <!-- 完善个人信息--step4 -->
        <div
            v-show="createAccountStep === 4"
            class="complete-personal-information"
        >
            <n-form
                
                ref="completePersonalInformationFormRef"
                :model="completePersonalInformationModel"
                :rules="completePersonalInformationModelRules"
            >
                <div v-show="curCompletePersonalInformationStep === 1" class="personal-base-info">
                    <n-form-item :theme-overrides="formItemThemeOverrides">
                        <n-radio-group
                            v-model:value="completePersonalInformationModel.gender"
                            name="radiogroup1"
                        >
                            <n-radio
                                v-for="rad in genderOtpsList"
                                :key="rad.value"
                                :value="rad.value"
                                size="medium"
                            >
                                {{ rad.label }}
                            </n-radio>
                        </n-radio-group>
                    </n-form-item>
                    <n-form-item
                        path="userName"
                        label="Your Name"
                        :theme-overrides="formItemThemeOverrides"
                    >
                        <n-input
                            v-model:value="
                                completePersonalInformationModel.userName
                            "
                            placeholder="Enter Your Name"
                            size="large"
                            @keydown.enter.prevent
                        />
                    </n-form-item>
                    <n-form-item
                        path="birthday"
                        label="Birthday"
                        :theme-overrides="formItemThemeOverrides"
                    >
                        <DateSelect
                            :value="completePersonalInformationModel.birthday"
                            @on-change="onSelectBirthady"
                        ></DateSelect>
                    </n-form-item>
                </div>
                <div v-show="curCompletePersonalInformationStep === 2" class="personal-upload-avator">
                    <n-form-item
                        path="avatar"
                        label="Your Avatar"
                        :theme-overrides="formItemThemeOverrides"
                    >
                        <div class="avatar-upload-cont">
                            <div v-if="completePersonalInformationModel?.avatar" class="profile-thumb">
                                <img
                                    :src="completePersonalInformationModel?.avatar"
                                    alt="avatar"
                                />
                                <n-progress
                                    v-show="isLoadingFile"
                                    type="line"
                                    :height="2"
                                    :percentage="currentUploadedFile?.uploadFilePercentage"
                                    :show-indicator="false"
                                ></n-progress>
                            </div>
                            <n-upload
                                ref="uploadRef"
                                :custom-request="customRequest"
                                :show-file-list="false"
                                accept="image/*"
                            >
                                <div class="btn-upload br8">
                                    <n-icon name="action" size="24">
                                        <img src="@/assets/icons/icon_plus_new.svg" />
                                    </n-icon>
                                    <span>Upload</span>
                                </div>
                            </n-upload>
                        </div>
                    </n-form-item>
                </div>
            </n-form>



            <div
                v-show="curCompletePersonalInformationStep === 3"
                class="personal-preference-procedure"
            >
                <div class="refresh-procedure-tip">
                    Don’t like these?
                    <span
                        class="btn-refresh"
                        @click="_handleRefreshInterestedList"
                    >
                        Refresh
                    </span>
                </div>
                <div class="procedure-list-cont">
                    <n-scrollbar style="height: 100%">
                        <div class="procedure-list-wrapper">
                            <div
                                v-for="(item, index) in curInterestedList"
                                :key="index"
                                class="procedure-list-item"
                                :class="{
                                    selected:
                                        completePersonalInformationModel.procedureSelected.includes(
                                            item?.id
                                        ),
                                }"
                                @click="_hancleSelcetProcedureItem(item)"
                            >
                                <div class="img-cont">
                                    <img :src="item.img" />
                                </div>
                                <div class="procedure-text">
                                    {{ item?.name }}
                                </div>
                            </div>
                        </div>
                    </n-scrollbar>
                </div>
            </div>

            <div class="btn-cont">
                <n-button text-color="#000000" style="border: 1px solid #000000" @click="skipCompletePersonalInformation">
                    Skip
                </n-button>
                <n-button :color="!isDisabledUserMemberPublish ? '#000000' : 'rgba(0, 0, 0, 0.2)'" text-color="#ffffff" :disabled="isDisabledUserMemberPublish" @click="_handlePublish">
                    Publish
                </n-button>
            </div>

            <div
                class="complete-personal-information-line"
                :class="{ 'two-complete-personal-information': curCompletePersonalInformationStep === 2}"
            >
                <div class="line">
                    <div class="weight-line" v-for="item in 3" :key="item" :class="{'active-line': curCompletePersonalInformationStep === item}"></div>
                </div>
                <div class="text">
                    {{ curCompletePersonalInformationStep }} of 3
                </div>
            </div>
        </div>

        <!-- 注册完成--step5 | step6 -->
        <div
            v-show="createAccountStep === 5 || createAccountStep === 6"
            class="register-done"
        >
            <div class="title">Welcome to Charm-Vibe</div>

            <div class="big-logo-cont">
                <img src="@/assets/images/layout/big_app_logo.png" />
            </div>

            <!-- <n-button
                v-if="createAccountStep === 5"
                color="#000000"
                text-color="#ffffff"
                class="login-in-done"
                @click="_handleShowLogin"
            >
                Log in
            </n-button> -->
            <n-button
                v-if="createAccountStep === 5"
                color="#000000"
                text-color="#ffffff"
                class="login-in-done"
                @click="_handleGoToHomepagePage"
            >
                Home
            </n-button>
            <n-button
                v-if="createAccountStep === 6"
                color="#000000"
                text-color="#ffffff"
                icon-placement="right"
                @click="_handleGoToMyProfilePage"
            >
                Let’s Set Up Your Profile
            </n-button>
        </div>

        <!-- 邮箱验证成功--step7 -->
        <div v-show="createAccountStep === 7" class="verify-success verify-step-container">
            <div class="img-cont">
                <img src="@/assets/images/layout/edit_password_success.png" />
            </div>
            <div class="title">Email verification successful</div>
            <div class="describe">
                <template v-if="registerEmail?.email">{{registerEmail.email}}</template>
                <template v-else>unkown email</template>
            </div>
            <div class="back-to-login-btn-cont">
                <n-button
                    color="#000000"
                    text-color="#ffffff"
                    icon-placement="right"
                    @click="createAccountStep = 3"
                >
                    Continue creating account
                </n-button>
            </div>
        </div>

        <!-- 设置新密码失败--step8 -->
        <div v-show="createAccountStep === 8" class="verify-fail verify-step-container">
            <div class="img-cont">
                <img src="@/assets/images/layout/edit_password_fail.png" />
            </div>
            <div class="title">Something went wrong</div>
            <div class="describe">Sorry, activation failed, please check or contact us!</div>
            <div class="back-to-login-btn-cont return-btn-cont">
                <n-button
                    color="#000000"
                    text-color="#ffffff"
                    @click="createAccountStep = 1"
                    >Return</n-button
                >
            </div>
        </div>


        <!--Charm-Vibe Image & Data Consent Form-->
        <n-modal v-model:show="isShowPrivacyModal" :mask-closable="false" to="#app">
            <PrivacyPolicyContent @on-close="_handleClosePrivacy"  @onConfirm="_handleConfirmPrivacy" />
        </n-modal>

        <!--Charm-Vibe Image & Data Consent Form-->
        <n-modal v-model:show="isShowTermServiceModal" :mask-closable="false" to="#app">
            <TermsServiceContent @on-close="_handleCloseTermService"  @onConfirm="_handleConfirmTermService" />
        </n-modal>
    </div>
</template>

<script lang="ts" setup>
import {
    NForm,
    NFormItem,
    NInput,
    NButton,
    NRadioGroup,
    NRadio,
    NIcon,
    NScrollbar,
    NProgress, 
    NUpload,
    NCheckbox,
    NModal,
} from "naive-ui";
import type { FormInst, FormItemRule, FormRules, UploadCustomRequestOptions } from "naive-ui";
import { ref, computed, watch, onMounted, nextTick } from "vue";
import { MessageAlert } from "@/composables/useMessageAlert";
// import ChoseUserIdentify from "./ChoseUserIdentify.vue";
import {
    GenderTypeList,
    REQUEST_SCCUESS_CODE,
    USER_INDENTIFY_KEY,
    UserRole,
    SourceType,
    MAX_FILE_SIZE,
    VUE_APP_IMG_BUCKET_NAME,
} from "@/constant";
import {
    validateEmail,
    validatePassword,
    validateUserName,
} from "@/utils/util";
import { useStore } from "vuex";
import type {
    FormItemThemeOverrides,
} from "@/types/themeOverrides";
import DateSelect from "@/components/DateSelect.vue";
import { useRegisterAct } from "@/composables/useRegisterAct";
import { useInterestedList } from "@/composables/useInterestedList";
import { useNavigatorSystem } from "@/composables/useNaviSystem";
import storage from "@/utils/storage";
import { useRouter } from "vue-router";
import { uploadImgToS3 } from "@/utils/s3-client";
import PrivacyPolicyContent from "@/views/other/modalModules/PrivacyPolicyContent.vue"
import TermsServiceContent from "@/views/other/modalModules/TermsServiceContent.vue"

const props = defineProps({
    currentStep: {
        type: Number,
        default: () => {
            return 1;
        },
    },
    curBaseInfoStep: {
        type: Number,
        default: () => {
            return 1;
        },
    },
});
const emits = defineEmits([
    "update:currentStep",
    "onLogin",
    "onChangeuserInfoStep",
    "onClose",
]);

const formItemThemeOverrides: FormItemThemeOverrides = {
    feedbackPadding: "12px 0",
};

const store = useStore();
const router = useRouter();
const {
    _clickVerifyEmailByApi,
    _userSetTheirProfileByApi,
    _isConfirmEmailByApi,
} = useRegisterAct();
const { curInterestedList, _initInterestedPage } = useInterestedList();
const { isMobile } = useNavigatorSystem();

const agreeAuthTermOfPrivacy = ref<boolean>(false);
const isShowPrivacyModal = ref<boolean>(false);
const isShowTermServiceModal = ref<boolean>(false);
const registerEmailFormRef = ref<FormInst | null>(null);
const createAccountStep = ref<number>(1);
const genderOtpsList = ref(GenderTypeList);
const showRegisterPassword = ref<boolean>(false);
const showRegisterConfirmPassword = ref<boolean>(false);
const registerEmail = ref<any>({
    email: "",
});
const registerEmailRules: FormRules = {
    email: [
        {
            required: true,
            trigger: ["input"],
            validator: (rule: FormItemRule, value: any) => {
                //console.log(rule, value);
                if (!value) {
                    return new Error("Please input");
                } else if (!validateEmail(value)) {
                    return new Error("Please enter a valid email address");
                }
                return true;
            },
        },
    ],
};
const cacheUserRole = ref<string>("USER");

const isDoctorRole = computed(() => {
    return cacheUserRole.value === UserRole.Doctor ? true : false;
})

const userNamePlaceholder = computed(() => {
    return isDoctorRole.value ? `Enter your legal name as it appears on the AHPRA register` : `Enter Your User Name`
})

const showRegisterEmailClearBtn = computed(() => {
    return registerEmail.value.email ? true : false;
});

const isDisabledRegisterEmailBtn = computed(() => {
    return registerEmail.value.email ? false : true;
});

const registerFormRef = ref<FormInst | null>(null);
const registerMessageModel = ref<any>({
    nickname: null,
    password: null,
    confirmPassword: null,
});

const showRegisterUserNameClearBtn = computed(() => {
    return registerMessageModel.value.nickname ? true : false;
});

const showRegisterPasswordClearBtn = computed(() => {
    return registerMessageModel.value.password ? true : false;
});

const showRegisterConfirmPasswordClearBtn = computed(() => {
    return registerMessageModel.value.confirmPassword ? true : false;
});

const isDisabledCreateAccount = computed(() => {
    return registerMessageModel.value.nickname &&
        registerMessageModel.value.password &&
        registerMessageModel.value.confirmPassword
        ? false
        : true;
});

const registerMessageModelRules: FormRules = {
    nickname: [
        {
            required: true,
            trigger: ["input"],
            validator: (rule: FormItemRule, value: any) => {
                //console.log(rule, value);
                if (!value) {
                    return new Error("Please input");
                } else if (!validateUserName(value)) {
                    return new Error("user name must least 5~50 letters");
                }
                return true;
            },
        },
    ],
    password: [
        {
            required: true,
            trigger: ["input"],
            validator: (rule: FormItemRule, value: any) => {
                //console.log(rule, value);
                if (!value) {
                    return new Error("Please input");
                } else if (!validatePassword(value)) {
                    return new Error("password must 6~25 letters, at least one special character or one uppercase letter");
                }
                return true;
            },
        },
    ],
    confirmPassword: [
        {
            required: true,
            trigger: ["input"],
            validator: (rule: FormItemRule, value: any) => {
                //console.log(rule, value);
                if (!value) {
                    return new Error("Please input");
                } else if (!validatePassword(value)) {
                    return new Error("password must 6~25 letters, at least one special character or one uppercase letter");
                }
                return true;
            },
        },
    ],
};

const curCompletePersonalInformationStep = ref<number>(1);
const completePersonalInformationFormRef = ref<FormInst | null>(null);
const completePersonalInformationModel = ref<any>({
    gender: "0",
    userName: null,
    birthday: null,
    procedureSelected: [],
    avatar: null
});

const uploadRef = ref<any>(null);
const currentUploadedFile = ref<any>(null);
const isLoadingFile = ref<boolean>(false);
const isLoadedSuccess = ref<boolean>(false);

const isDisabledUserMemberPublish = computed(() => {
    return completePersonalInformationModel.value.userName ||
        completePersonalInformationModel.value.procedureSelected
        ? false
        : true;
});
const completePersonalInformationModelRules: FormRules = {
    gender: [
        {
            required: false,
        },
    ],
    userName: [
        {
            required: false,
        },
    ],
    avatar: [
        {
            required: false,
        },
    ],
    procedureSelected: [
        {
            required: false,
        },
    ],
};

const onSelectBirthady = (date: { year: any; month: any; day: any }) => {
    const { year, month, day } = date;
    completePersonalInformationModel.value.birthday = `${year}-${month}-${day}`;
};

const _handleClearRegisterEmail = () => {
    registerEmail.value.email = "";
};

const _handleValidEmail = () => {
    if (isDisabledRegisterEmailBtn.value) {
        MessageAlert("Please input correct email");
        return;
    }
    //createAccountStep.value = 2;
    registerEmailFormRef.value?.validate(async (errors) => {
        if (!errors) {
            const params: any = {
                email: registerEmail.value.email,
                userRole: cacheUserRole.value,
                source: SourceType.Register
            };
            const res: any = await _clickVerifyEmailByApi(params);
            if (res?.code === REQUEST_SCCUESS_CODE) {
                //下一步
                createAccountStep.value = 2;
            } else {
                let errMess = res?.msg || "email verify failed";
                MessageAlert(errMess);
            }
        } else {
            //console.error(errors);
            const errMess =
                errors[0] && errors[0][0]?.message
                    ? errors[0][0]?.message
                    : "Please enter a valid email address";
            MessageAlert(errMess);
        }
    });
};

const _hanleResendEmail = () => {
    _handleValidEmail();
};

// const _hanleCheckVerify = async () => {
//     const params: any = {
//         email: registerEmail.value.email,
//         userRole: cacheUserRole.value,
//     };
//     //createAccountStep.value = 3;
//     const res: any = await _isConfirmEmailByApi(params);
//     if (res?.code === REQUEST_SCCUESS_CODE) {
//         //下一步
//         createAccountStep.value = 3;
//     } else {
//         let errMess = res?.msg || "email confirm failed";
//         MessageAlert(errMess);
//     }
// };

const _handleClearRegisterUserName = () => {
    registerMessageModel.value.nickname = "";
};

const _handleClearRegisterPassword = () => {
    registerMessageModel.value.password = "";
};

const _handleClearRegisterConfirmPassword = () => {
    registerMessageModel.value.confirmPassword = "";
};

const _handleShowRegisterPassword = () => {
    showRegisterPassword.value = !showRegisterPassword.value;
};

const _handleShowRegisterConfirmPassword = () => {
    showRegisterConfirmPassword.value = !showRegisterConfirmPassword.value;
};

const updateCreateAccountStep = (step: number) => {
    emits("update:currentStep", step);
};

const updateCompleteInfoStep = (step: number) => {
    emits("onChangeuserInfoStep", step);
};

const _handleCreateAccount = () => {
    if (isDisabledCreateAccount.value) {
        MessageAlert("Please enter");
        return;
    }
    if (
        registerMessageModel.value.password !==
        registerMessageModel.value.confirmPassword
    ) {
        MessageAlert("confirmPassword must be consistent");
        return;
    }
    //createAccountStep.value = 4;
    registerFormRef.value?.validate((errors) => {
        if (!errors) {
            try {
                const userType = storage.get(USER_INDENTIFY_KEY) || 1;
                const params = {
                    email: registerEmail.value.email,
                    nickname: registerMessageModel.value.nickname,
                    password: registerMessageModel.value.password,
                    userRole:
                        Number(userType) === 1
                            ? UserRole.User
                            : UserRole.Doctor,
                };
                store.dispatch("user/userRegisterEmail", params).then((res:any)=>{
                    console.log("user/userRegisterEmail========>>>>>", res)
                    createAccountStep.value = 4;
                }).catch((error: any) => {
                    console.error("user/userRegisterEmail========>>>>>", error)
                });
            } catch (error: any) {
                const errMess = error?.message || "register failed";
                MessageAlert(errMess);
            }
        } else {
            //console.error(errors);
            const errMess =
                errors[0] && errors[0][0]?.message
                    ? errors[0][0]?.message
                    : "Please enter a valid email address";
            MessageAlert(errMess);
        }
    });
};

watch(
    () => props.currentStep,
    (newV) => {
        createAccountStep.value = newV;
    },
    { immediate: true }
);

watch(
    () => createAccountStep.value,
    (newV) => {
        updateCreateAccountStep(newV);
    },
    { immediate: true }
);

watch(
    () => props.curBaseInfoStep,
    (newV) => {
        curCompletePersonalInformationStep.value = newV;
    },
    { immediate: true }
);

watch(
    () => curCompletePersonalInformationStep.value,
    (newV) => {
        updateCompleteInfoStep(newV);
    },
    { immediate: true }
);

// 注册-选择完职业之后点击next按钮
// const _handleChooseCareerNext = (type: number) => {
//     if (type === 1) {
//         createAccountStep.value = 4;
//     } else if (type === 2) {
//         createAccountStep.value = 6;
//     }
// };

// 读取选择的文件
const readFile = (file: any, cb: any) => {
    if (file?.success) {
        const curFile = file?.file;
        const reader = new FileReader();
        reader.readAsDataURL(curFile);
        reader.onload = (e) => {
            cb &&
                cb({
                    imgSrc: file?.location || e.target?.result,
                    file: file,
                });
        };
    } else {
        const errMess = "file upload failed";
        MessageAlert(errMess);
    }
};

const customRequest = async ({ file }: UploadCustomRequestOptions) => {
    //console.log("customRequest====why222222222222222===>", file);
    isLoadingFile.value = true;
    isLoadedSuccess.value = false;
    let curUploadFile = {
        id: file?.id,
        isLoadingFile: isLoadingFile.value,
        isLoadedSuccess: isLoadedSuccess.value,
        uploadFilePercentage: file?.percentage,
        imgSrc: "",
        fileType: file.type,
    };
    currentUploadedFile.value = { file: file, ...curUploadFile };
    const resp = await uploadImgToS3(
        {
            file: file?.file as File,
            maxFileSize: MAX_FILE_SIZE,
            bucketName: VUE_APP_IMG_BUCKET_NAME,
        },
        (progressEvent: any) => {
            const percentCompleted = Math.ceil(
                (progressEvent.loaded * 100) / progressEvent.total
            );
            //console.log("上传进度：" + percentCompleted + "%", file);
            currentUploadedFile.value.uploadFilePercentage = percentCompleted;
        }
    );
    isLoadingFile.value = false;
    if (resp?.success) {
        isLoadedSuccess.value = true;
        const curImgSrc = resp?.location || "";
        currentUploadedFile.value.imgSrc = curImgSrc;
        currentUploadedFile.value.isLoadingFile = false;
        currentUploadedFile.value.isLoadedSuccess = true;
        currentUploadedFile.value.uploadFilePercentage = 100;
        
    } else {
        isLoadedSuccess.value = false;
        currentUploadedFile.value.imgSrc = "";
        currentUploadedFile.value.fileType = "";
        currentUploadedFile.value.isLoadingFile = false;
        currentUploadedFile.value.isLoadedSuccess = false;
        currentUploadedFile.value.uploadFilePercentage = 0;
        const errMess = "file upload failed";
        MessageAlert(errMess);
    }
    completePersonalInformationModel.value.avatar = currentUploadedFile.value?.imgSrc;
    uploadRef.value?.clear();
    //console.log("uploadImgToS3===>", resp);
};

//注册账号-完善个人信息时跳过
const skipCompletePersonalInformation = () => {
    if (curCompletePersonalInformationStep.value < 3) {
        curCompletePersonalInformationStep.value++;
    } else {
        createAccountStep.value++;
    }
};

const _handleShowLogin = () => {
    emits("onLogin");
    createAccountStep.value = 1;
};

const _handleGoToHomepagePage = () => {
    router.push({ path: "/" });
    nextTick(() => {
        emits("onClose");
    });
};

const _handleRefreshInterestedList = () => {
    _initInterestedPage();
};

const _hancleSelcetProcedureItem = (item: any) => {
    const findIdx =
        completePersonalInformationModel.value.procedureSelected.findIndex(
            (ele: any) => ele === item?.id
        );
    if (findIdx > -1) {
        completePersonalInformationModel.value.procedureSelected.splice(
            findIdx,
            1
        );
    } else {
        completePersonalInformationModel.value.procedureSelected.push(item?.id);
    }
};

const _goToPageDoctorProfile = () => {
    router.push({ path: "/user/profile", query: { from: "user" } });
    nextTick(() => {
        emits("onClose");
    });
    // if(isMobile.value){
    //     router.push({ path: "/mobile/user/profile", query: { from: "user" } });
    // }else{
    //     router.push({ path: "/user/profile", query: { from: "user" } });
    //     nextTick(() => {
    //         emits("onClose");
    //     });
    // }
};

const _handleGoToMyProfilePage = () => {
    _goToPageDoctorProfile();
};

const _handlePublish = () => {
    //createAccountStep.value = 6;
    completePersonalInformationFormRef.value?.validate(async (errors) => {
        if (!errors) {
            const params = {
                email: registerEmail.value.email,
                nickname: completePersonalInformationModel.value.userName,
                birthday: completePersonalInformationModel.value.birthday,
                gender: completePersonalInformationModel.value.gender,
                img: completePersonalInformationModel.value.avatar,
                interested:
                    completePersonalInformationModel.value.procedureSelected,
            };
            const res: any = await _userSetTheirProfileByApi(params);
            if (res?.code === REQUEST_SCCUESS_CODE) {
                createAccountStep.value = 6;
            } else {
                const errMess = res?.msg || "api failed";
                MessageAlert(errMess);
            }
        } else {
            //console.error(errors);
            const errMess =
                errors[0] && errors[0][0]?.message
                    ? errors[0][0]?.message
                    : "Please check errors";
            MessageAlert(errMess);
        }
    });
};

const handleShowPrivacyPolicy = () => {
    isShowPrivacyModal.value = true;
}
const _handleClosePrivacy = () => {
    isShowPrivacyModal.value = false;
}
const _handleConfirmPrivacy = () => {
    isShowPrivacyModal.value = false;
}
const _handleShowTermsOfService = () => {
    isShowTermServiceModal.value = true;
}
const _handleCloseTermService = () => {
    isShowTermServiceModal.value = false;
}
const _handleConfirmTermService = () => {
    isShowTermServiceModal.value = false;
}

const _initRegisterPage = () => {
    const cacheUserRoleLocal = store.getters["user/getUserRole"];
    cacheUserRole.value = cacheUserRoleLocal;

    const cacheUserThirdEmail = store.getters["user/getUserThirdEmail"];
    const loginEmail = store.getters["user/getLoginEmail"];
    registerEmail.value.email = loginEmail || cacheUserThirdEmail;
};

onMounted(() => {
    nextTick(() => {
        _initRegisterPage();
    });
});
</script>

<style lang="scss" scoped>
.register-message-cont {
    .email-address-input-cont {
        margin-top: 20px;
        .next-btn-cont {
            position: absolute;
            left: 60px;
            right: 60px;
            bottom: 78px;

            .term-of-privacy{
                padding-bottom: 12px;
                color: rgba(0, 0, 0, 0.6);
                text-align: left;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;

                span {
                    color: #2A8CFF;
                    // text-decoration-line: underline;
                    cursor: pointer;
                }
            }

            :deep(.n-button) {
                width: 100%;
                height: 60px;
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 16px;
            }
        }

        .tips-privacy-container{
            position: absolute;
            left: 60px;
            right: 60px;
            bottom: 40px;
            margin-top: 20px;

            .log-in-tip {
                color: rgba(0, 0, 0, 0.6);
                text-align: center;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;

                span {
                    color: #2A8CFF;
                    // text-decoration-line: underline;
                    cursor: pointer;
                }
            }
        }


    }

    .verify-identity-cont {
        margin-top: 140px;

        .verify-identity-icon{
            display: flex;
            align-items: center;
            justify-content: center;
            .setpassword-icon{
                width: 80px;
                height: 80px;

                img{
                    width: 100%;
                    height: 100%;
                    object-fit: fill;
                }
            }
        }

        .verify-identity-title{
            margin-top: 40px;
            text-align: center;

            span{
                color: #000;
                text-align: center;
                font-size: 24px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }
        }

        .has-sended-message {
            margin-top: 16px;
            text-align: center;
            color: rgba(0, 0, 0, 0.40);
            text-align: center;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 180%;   

            span {
                color: rgba(0, 0, 0, 0.60);
            }
        }

        .btn-group {
            display: flex;
            position: absolute;
            left: 60px;
            right: 60px;
            bottom: 40px;
            align-items: center;
            justify-content: center;

            .custom-btn {
                display: flex;
                width: 100%;
                height: 60px;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 16px;
                cursor: pointer;
            }

            .resend-btn {
                color: #ffffff;
                background-color: #000000;
                // color: #2A8CFF;
                // background-color: #ffffff;
                // text-decoration: underline;
            }

            .check-btn {
                color: #ffffff;
                background-color: #000000;
            }
        }
    }

    .account-message-input-cont {
        margin-top: 12px;

        :deep(.n-input .n-input__suffix) {
            img {
                width: 20px;
                height: 16px;
                cursor: pointer;
            }
        }

        .create-account-btn-cont {
            position: absolute;
            left: 60px;
            right: 60px;
            bottom: 40px;

            :deep(.n-button) {
                width: 100%;
                height: 60px;
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 16px;
            }
        }
    }

    .choose-career {
        margin-top: 94px;
    }

    .complete-personal-information {

        :deep(.n-date-picker) {
            width: 100%;
        }

        :deep(.n-radio) {
            justify-content: center;
            .n-radio__label {
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 24px */
            }
        }

        :deep(.n-radio.n-radio--checked) {
            .n-radio__label {
                color: #000000;
            }
        }

        .personal-upload-avator{
            .avatar-upload-cont{
                display: flex;
                margin-top: 8px;
                align-items: center;
                gap: 12px;
                .profile-thumb{
                    position: relative;
                    margin-right: 40px;

                    >img {
                        width: 152px;
                        height: 152px;
                        object-fit: cover;
                        border-radius: 50%;
                        overflow: hidden;
                    }

                    .n-progress {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        z-index: 1;
                    }
                }
                .btn-upload{
                        display: flex;
                        width: 152px;
                        height: 152px;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border: 1px solid rgba(0, 0, 0, 0.20);
                        background-color: #ffffff;
                        cursor: pointer;

                        span{
                            padding-top: 4px;
                            color: #5C5C66;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }
                }
            }
        }

        .personal-preference-procedure {
            .refresh-procedure-tip {
                color: #000000;
                text-align: center;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;

                span {
                    color: #2A8CFF;
                    // text-decoration-line: underline;
                    cursor: pointer;
                }

                .btn-refresh {
                    cursor: pointer;
                }
            }

            .procedure-list-cont {
                width: calc(100% + 12px);
                height: 400px;
                margin-top: 12px;

                .procedure-list-wrapper {
                    display: flex;
                    width: calc(100% - 12px);
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: flex-start;
                    flex-wrap: wrap;
                    gap: 16px;
                    .procedure-list-item {
                        margin-top: 12px;
                        width: 98px;

                        &.selected .img-cont {
                            border: 2px solid rgba(0, 0, 0, 1);
                        }

                        .img-cont {
                            width: 98px;
                            height: 98px;
                            border: 2px solid rgba(0, 0, 0, 0.2);
                            box-sizing: border-box;
                            border-radius: 50%;
                            overflow: hidden;
                            cursor: pointer;

                            img {
                                width: 98px;
                                height: 98px;
                            }
                        }

                        .procedure-text {
                            color: rgba(0, 0, 0, 0.8);
                            text-align: center;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }
                    }
                }
            }
        }

        .btn-cont {
            position: absolute;
            display: flex;
            left: 60px;
            right: 60px;
            bottom: 100px;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            gap: 16px;

            :deep(.n-button) {
                width: 232px;
                height: 60px;  
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 16px;
            }
        }

        .complete-personal-information-line {
            position: absolute;
            left: 60px;
            right: 60px;
            bottom: 40px;
            margin-top: 20px;

            // &.two-complete-personal-information {
            //     .line .weight-line {
            //         position: relative;
            //         left: 50%;
            //     }
            // }

            .line {
                display: flex;
                height: 1px;
                width: 100%;
                background-color: #9fc1ff;

                .weight-line {
                    flex: 1;
                }
                .active-line{
                    height: 2px;
                    background-color: #000000;
                    transform: translateY(-0.5px);
                }
            }

            .text {
                margin-top: 20px;
                color: rgba(0, 0, 0, 0.6);
                text-align: center;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }
    }

    .register-done {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .title {
            color: #000;
            text-align: center;
            
            font-size: 32px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }

        .big-logo-cont {
            margin-top: 66px;
            width: 240px;
            height: 256px;
        }

        :deep(.n-button) {
            position: absolute;
            left: 60px;
            right: 60px;
            bottom: 40px;
            height: 60px;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 180%;
        }

        :deep(.login-in-done.n-button span.n-button__content){
            background: linear-gradient(93deg, #8ef, #ff7de7);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    .verify-step-container {
        margin-top: 74px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        color: rgba(0, 0, 0, 0.2);
        text-align: center;
        
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;

        .img-cont {
            width: 112px;
            height: 112px;

            img {
                width: 112px;
                height: 112px;
            }
        }

        .title {
            margin-top: 24px;
            color: rgba(0, 0, 0, 0.6);
        }

        .describe {
            margin-top: 24px;
            font-size: 16px;
            font-weight: 600;
        }

        .back-to-login-btn-cont {
            position: absolute;
            left: 60px;
            right: 60px;
            bottom: 40px;
            height: 60px;

            :deep(.n-button) {
                width: 100%;
                height: 60px;
                
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 16px;
            }
        }
    }
}
@media screen and (max-width: 1024px) and (min-width: 744px) {
}
@media screen and (max-width: 744px) {
    .register-message-cont {
        .email-address-input-cont {
            .next-btn-cont {
                position: absolute;
                left: 12px;
                right: 12px;
            }
            .log-in-tip {
                margin-top: 30px;
            }
        }

        .verify-identity-cont {
            margin-top: 63px;

            .verify-identity-title{
                margin-top: 24px;

                span{
                    font-size: 18px;
                }
            }
            .has-sended-message {
                font-size: 14px; 
            }
            .btn-group {
                position: absolute;
                left: 12px;
                right: 12px;

                .custom-btn {
                    height: 60px;
                    font-size: 18px;
                }
            }
        }

        .account-message-input-cont {
            margin-top: 12px;

            .create-account-btn-cont {
                position: absolute;
                left: 12px;
                right: 12px;
                bottom: 40px;
            }
        }

        .choose-career {
            margin-top: 48px;
        }

        .complete-personal-information {
            :deep(.n-radio) {
                .n-radio__label {
                    font-size: 14px;
                }
            }
            .personal-upload-avator{
                .avatar-upload-cont{
                    .profile-thumb{
                        margin-right: 16px;

                        >img {
                            width: 120px;
                            height: 120px;
                        }
                    }
                    .btn-upload{
                            width: 120px;
                            height: 120px;
                    }
                }
            }
            .personal-preference-procedure {
                .procedure-list-cont {
                    height: 260px;
                    .procedure-list-wrapper {
                        .procedure-list-item {
                            .procedure-text {
                                display: -webkit-box;
                                max-height: 40px;
                                -webkit-line-clamp: 2;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;
                                -webkit-box-direction: vertical;
                            }
                        }
                    }
                }
            }

            .btn-cont {
                position: absolute;
                left: 12px;
                right: 12px;
                bottom: 100px;
                gap: 12px;

                :deep(.n-button) {
                    width: unset;
                    flex: 1;
                }
            }

            .complete-personal-information-line {
                position: absolute;
                left: 12px;
                right: 12px;
                bottom: 40px;

                &.two-complete-personal-information {
                    margin-top: 12px;
                }

            }
        }

        .register-done {
            margin-top: 136px;
            .title {
                font-size: 28px;
            }

            .big-logo-cont {
                margin-top: 96px;
                width: 120px;
                height: 128px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: fill;
                }
            }

            :deep(.n-button) {
                position: absolute;
                left: 20px;
                right: 20px;
                margin-top: 48px;
            }
        }

        .verify-step-container {
            margin-top: 120px;
            font-size: 14px;

            .img-cont {
                width: 60px;
                height: 60px;

                img {
                    width: 60px;
                    height: 60px;
                }
            }

            .title {
                margin-top: 14px;
            }

            .describe {
                margin-top: 12px;
                font-size: 12px;
                font-weight: 600;
            }

            .back-to-login-btn-cont {
                position: absolute;
                left: 20px;
                right: 20px;
                bottom: 40px;
                height: 60px;

                :deep(.n-button) {
                    width: 100%;
                    height: 60px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 16px;
                }
            }
        }
    }

    .register-mobile-cont {
        :deep(.n-input .n-input__input-el) {
            height: 56px;
        }
        :deep(.n-select .n-base-selection-label) {
            min-height: 56px;
        }
    }
}
</style>
